@if (!sent()) {
  <form
    class="auth-form"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    novalidate
  >
    <p class="auth-form__intro">
      Introduce tu correo y te enviaremos un enlace para restablecer la
      contraseña.
    </p>

    <app-input
      id="auth-forgot-email"
      label="Correo electrónico"
      type="email"
      placeholder="tu@correo.com"
      formControlName="email"
    />

    @if (errorMessage()) {
      <p class="auth-form__error" role="alert">{{ errorMessage() }}</p>
    }

    @if (showNoAccountHint()) {
      <p class="auth-form__hint">{{ copy.NO_ACCOUNT_HINT }} <button type="button" class="auth-form__inline-link" (click)="switchToRegister()">{{ copy.NO_ACCOUNT_LINK }}</button> {{ copy.NO_ACCOUNT_SUFFIX }}</p>
    }

    <app-button
      variant="primary"
      size="lg"
      type="submit"
      [loading]="loading()"
      [disabled]="loading() || remaining() > 0"
    >
      @if (remaining() > 0) {
        {{ waitLabel() }}
      } @else {
        Enviar enlace
      }
    </app-button>

    <div class="auth-form__links">
      <button type="button" class="auth-form__link" (click)="switchToLogin()">
        Volver al inicio de sesión
      </button>
    </div>
  </form>
} @else {
  <div class="auth-form__sent">
    <p class="auth-form__sent-text">
      Te enviamos un correo a <strong>{{ sentToEmail() }}</strong> con las
      instrucciones para recuperar tu contraseña. Revisa también la carpeta de
      spam.
    </p>
    <app-button variant="primary" size="md" (click)="switchToLogin()">
      Volver al inicio de sesión
    </app-button>
  </div>
}
